import { createWebHistory, createRouter } from 'vue-router'
import ApprovalView from '../views/ApprovalView.vue'
import LoginView from '../views/LoginView.vue'
import maintenanceService from '../services/maintenanceService.js'

const routes = [
  {
    path: '/',
    redirect: () => {
      const token = localStorage.getItem('approvalSystemToken')
      return token ? '/freigabe' : '/login'
    }
  },
  { 
    name: 'freigabe',
    path: '/freigabe', 
    component: ApprovalView,
    meta: { requiresAuth: true }
  },
  { 
    name: 'login',
    path: '/login', 
    component: LoginView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('approvalSystemToken')
      if (token) {
        next('/freigabe')
      } else {
        next()
      }
    }
  }
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes,
})

// Navigation Guard hinzufügen
router.beforeEach(async (to, from, next) => {
  // Zuerst Maintenance-Status prüfen
  try {
    const isMaintenance = await maintenanceService.forceCheck()
    
    if (isMaintenance) {
      // Bei Wartungsarbeiten: Navigation stoppen, aber nicht umleiten
      // Das MaintenanceModal wird automatisch angezeigt
      next(false)
      return
    }
  } catch (error) {
    console.warn('Maintenance check failed during navigation:', error)
    // Bei Fehlern: vorsichtshalber weiterleiten, aber Maintenance-Modal wird trotzdem angezeigt
  }

  // Dann normale Auth-Prüfung
  const token = localStorage.getItem('approvalSystemToken') // Token-basierte Auth-Prüfung

  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router

